/** Display name for admin/platform quotations (isAdminOffer). */
export const EUROASIANN_OFFER_LABEL = 'Euroasiann Offer';
